import React from 'react';

export default function MainContainer(props) {
  const { children, className, ...rest } = props;

  return (
    <main className={className} {...rest}>
      {children}
    </main>
  );
}
